import {
  Badge,
  TextItemCategory,
  type TextItemCategoryProps,
  type BadgeProps,
} from '..'

export type BadgeCategoryProps = BadgeProps & TextItemCategoryProps

export function BadgeItemCategory({
  categoryId,
  withInsuranceInfo,
  withBreadcrumbNames,
  ...props
}: BadgeCategoryProps) {
  return (
    <Badge color='gray' {...props}>
      <TextItemCategory
        categoryId={categoryId}
        withInsuranceInfo={withInsuranceInfo}
        withBreadcrumbNames={withBreadcrumbNames}
      />
    </Badge>
  )
}
